/**
 * Push notification events for the Event Bus.
 *
 * @enum PushNotification
 * @package App/Event
 * @project ChalkySticks App
 */
export enum PushNotification {
	Error = 'pushNotification:error',
	Opened = 'pushNotification:opened',
	Received = 'pushNotification:received',
	Registered = 'pushNotification:registered',
}
